// @flow

const TRANSPORTERS: Map<string, TransportType> = new Map();

export type TransportType = {
  pageview?: PageViewType => void,
  event?: EventType => void,
  goal?: GoalType => void,
  conversion?: ConversionType => void
};

export function addTransport(key: string, transport: TransportType): boolean {
  TRANSPORTERS.set(key, transport);
  return TRANSPORTERS.get(key) === transport;
}

export function removeTransport(key: string): boolean {
  return TRANSPORTERS.delete(key);
}

type TrackingMethod = 'pageview' | 'event' | 'goal' | 'conversion';
type TrackingData = PageViewType | EventType | GoalType | ConversionType;

function track(method: TrackingMethod, data: TrackingData) {
  TRANSPORTERS.forEach(transport => {
    try {
      const fn = transport[method];
      if (fn) {
        fn(data);
      }
    } catch (e) {
      if (__DEV__) {
        console.error(e);
      }
    }
  });
}

export type PageViewType = {
  location: {
    pathname: string,
    search: string
  },
  title: string
};

export function pageview({
  location = document.location,
  title = document.title
}: PageViewType = {}): void {
  return track('pageview', { location, title });
}

export type EventType = {
  category: string,
  action: string,
  label?: string,
  value?: number
};

export function event(options: EventType): void {
  return track('event', options);
}

export type GoalType =
  | number
  | string
  | {
      name: string,
      value: string | null,
      data?: mixed,
      noQueue?: boolean
    };

export function goal(options: GoalType): void {
  return track('goal', options);
}

export type ConversionType = {
  ref: string,
  affiliation: string,
  product: {
    name: string,
    code: string,
    category: string,
    value?: number
  },
  revenue: number,
  tax: number,
  fee: number,
  currency?: 'DKK'
};

export function conversion(options: ConversionType): void {
  return track('conversion', options);
}
